export default __webpack_public_path__ + "static/media/0176.ed403489.png";